import React, { useState } from "react";
import { BarChart3, Film, Tv, Users, Radio, Award, User2, Clapperboard, ShoppingBag, Shield } from "lucide-react";
import { useAuth } from "../lib/auth";
import Navbar from "../components/Navbar";

import Overview from "../components/admin/OverviewTab";
import Catalog from "../components/admin/CatalogTab";
import Episodes from "../components/admin/EpisodesTab";
import ScreensAdmin from "../components/admin/ScreensTab";
import SnacksAdmin from "../components/admin/SnacksTab";
import GCRTheaters from "../components/admin/GCRTheatersTab";
import FestivalsAdmin from "../components/admin/FestivalsTab";
import CreatorApplications from "../components/admin/ApplicationsTab";
import UsersAdmin from "../components/admin/UsersTab";

const TABS = [
  { id: "overview", label: "Overview", icon: BarChart3, Cmp: Overview },
  { id: "catalog", label: "Catalog", icon: Film, Cmp: Catalog },
  { id: "episodes", label: "Episodes", icon: Tv, Cmp: Episodes },
  { id: "screens", label: "GCR Multiplex", icon: Clapperboard, Cmp: ScreensAdmin },
  { id: "snacks", label: "Snacks Menu", icon: ShoppingBag, Cmp: SnacksAdmin },
  { id: "gcr", label: "GCR Theaters", icon: Radio, Cmp: GCRTheaters },
  { id: "festival", label: "Festivals", icon: Award, Cmp: FestivalsAdmin },
  { id: "applications", label: "Applications", icon: User2, Cmp: CreatorApplications },
  { id: "users", label: "Users", icon: Users, Cmp: UsersAdmin },
];

export default function Admin() {
  const { user } = useAuth();
  const [tab, setTab] = useState("overview");
  if (!user?.is_admin) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center">
        <p>Admin access required.</p>
      </div>
    );
  }
  const active = TABS.find((t) => t.id === tab) || TABS[0];
  const Active = active.Cmp;
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <main className="pt-24 px-6 lg:px-12 max-w-[1600px] mx-auto pb-20">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <Shield className="w-7 h-7 text-[#E50914]" />Admin Dashboard
          </h1>
        </div>
        <div className="border-b border-white/10 mb-8 flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`admin-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`px-5 py-3 text-sm font-medium flex items-center gap-2 border-b-2 transition-colors whitespace-nowrap ${
                tab === t.id ? "border-[#E50914] text-white" : "border-transparent text-gray-400 hover:text-white"
              }`}
            >
              <t.icon className="w-4 h-4" /> {t.label}
            </button>
          ))}
        </div>
        <Active />
      </main>
    </div>
  );
}
